'use client';

import Link from 'next/link';
import classes from './HorizontalTextCard.module.scss';
import { Button, Container } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { Title } from '../../Title/Title';

type HorizontalTextCardProps = {
  title: string;
  description: string;
  backgroundGradient: string;
  button: string;
  buttonColor: string;
  buttonHref: string;
  version: string;
};

export const HorizontalTextCard = ({ data }: { data: HorizontalTextCardProps }) => {
  const { title, description, backgroundGradient, button, buttonColor, buttonHref, version } = data;
  useAOS();

  return (
    <div
      style={{ backgroundImage: backgroundGradient }}
      className={`${classes.fullWidthWrapper} ${version === 'dark' && classes.dark}`}
      data-aos="fade-up"
    >
      <Container>
        <section className={classes.horizontalSection}>
          <Title title={title} />
          <p>{description}</p>
          <Button
            className={classes.button}
            component={Link}
            href={buttonHref}
            my="lg"
            data-aos="zoom-in"
          >
            {button}
          </Button>
        </section>
      </Container>
    </div>
  );
};
